/* unplugin-vue-components disabled */import script from "./global-search.vue?vue&type=script&lang=ts&setup=true"
export * from "./global-search.vue?vue&type=script&lang=ts&setup=true"

import "./global-search.vue?vue&type=style&index=0&id=095742b1&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-095742b1"]])

export default __exports__